import { Participant } from '@/common/types/user/participant';

export function getDateOfBirth(participant: Participant): string {
    return participant?.dob ? participant.dob : participant?.dateOfBirth;
}
